import script from "./policy-details-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./policy-details-modal.vue?vue&type=script&setup=true&lang=js"

import "./policy-details-modal.vue?vue&type=style&index=0&id=da080984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da080984"]])

export default __exports__